export default __webpack_public_path__ + "static/media/SWT1000.34I-29561_-17086_0.0cdace24.jpg";